<template>
	<page>
		<module>
			<view-list :work-type="workType" ref="view" selector :batch-edit="auth('b_output_edit')" :view-config="auth('b_output_viewmanage')">
				<template #search>
					<m-search ref="search">
						<m-search-item label="工单编号">
							<c-input name="work_code"></c-input>
						</m-search-item>
						<m-search-item label="产品编号">
							<c-input name="product_code"></c-input>
						</m-search-item>
						<m-search-item label="产品名称">
							<c-input name="product_name"></c-input>
						</m-search-item>
						<m-search-item label="产品规格">
							<c-input name="product_spec"></c-input>
						</m-search-item>
						<m-search-item label="报工类型">
							<c-select name="output_types" :options="outputTypeDic" multiple ></c-select>
						</m-search-item>
						<m-search-item label="生产人员">
							<c-select name="output_user_ids" async multiple @search="searchOutputUser" ></c-select>
						</m-search-item>
						<m-search-item label="工序编号">
							<c-input name="process_code"></c-input>
						</m-search-item>
						<!-- <m-search-item label="工序名称">
							<c-input name="process_name"></c-input>
						</m-search-item> -->
						<m-search-item label="工序">
							<c-select name="process_ids" multiple async @search="searchProcess"></c-select>
						</m-search-item>
						<m-search-item label="审批状态">
							<c-select name="states" :options="auditStateDic" multiple ></c-select>
						</m-search-item>
						<m-search-item label="检验方式">
							<c-select name="test_modes" :options="testModeDic" multiple ></c-select>
						</m-search-item>
						<m-search-item label="质检状态">
							<c-select name="test_states" :options="testStateDic" multiple ></c-select>
						</m-search-item>
						<m-search-item label="报工创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
						<m-search-item label="报工开始时间" colspan="2">
							<c-datetime range start-name="realstart_start_date" end-name="realstart_end_date"></c-datetime>
						</m-search-item>
						<m-search-item label="报工结束时间" colspan="2">
							<c-datetime range start-name="realend_start_date" end-name="realend_end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button color="main" v-if="auth('b_output_create')" v-lock="lock('b_output_create')" prepend-icon="tf-add" @click="editOutput()">创建报工</c-button>
					<c-button v-if="auth('b_output_export')" v-lock="lock('b_output_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_output_export')" v-lock="lock('b_output_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
				</template>

				<template #batchOperate="{data}">
					<c-button v-if="auth('b_output_export')" v-lock="lock('b_output_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_output_export')" v-lock="lock('b_output_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button v-if="auth('b_output_print')" v-lock="lock('b_output_print')" prepend-icon="tf-print" @click="$refs.view.batchExportByTemplate()">打印</c-button>
                    <c-dropdown>
                        <c-button prepend-icon="tf-batch">批量操作</c-button>

                        <template #menu>
                            <c-menu-list>
                                <c-menu-item v-if="auth('b_output_audit')" v-lock="lock('b_output_audit')" icon="tf-approve" @click="batchAuditOutput">审批</c-menu-item>
                                <c-menu-item v-if="auth('b_output_edit_price')" v-lock="lock('b_output_edit_price')" icon="tf-edit" @click="batchEditOutputPrice">修改工资</c-menu-item>
                                <c-menu-item v-if="auth('b_output_delete')" v-lock="lock('b_output_delete')" icon="tf-trash" color="red" :hollow="true" @click="batchRemoveOutput">删除</c-menu-item>
                            </c-menu-list>
                        </template>
                    </c-dropdown>

				</template>

				<template #otherOperate>
					<c-button v-if="auth('b_output_log')" v-lock="lock('b_output_log')" prepend-icon="tf-operate-record" @click="$refs.view.loadWorkLogDetail()">操作记录</c-button>
				</template>

				<!--报工类型-->
				<template #output_type="{data}">
					<c-state dict="outputTypeDic" :value="data.output_type"></c-state>
				</template>

				<!--返工类型-->
				<template #rework_after_type="{data}">
					<c-state v-if="data.output_type == 2 && data.rework_after_type" dict="reworkAfterTypeDic" :value="data.rework_after_type"></c-state>
					<span v-else>-</span>
				</template>

				<!--报工良品率-->
				<template #fine_ratio="{data}">
					{{data.fine_ratio}}%
				</template>
				
				<!--检验方式-->
				<template #test_mode="{data}">
					<c-state dict="testModeDic" :value="data.test_mode"></c-state>
				</template>
				
				<!--检验状态-->
				<template #test_state="{data}">
					<c-state dict="testStateDic" :value="data.test_state"></c-state>
				</template>
				
				<!--质检人-->
				<template #test_user_realname="{data}">
					<span v-if="data.test_state == 3">{{data.test_user_realname}}</span>
					<span v-else>-</span>
				</template>
				
				<!--质检时间-->
				<template #test_date="{data}">
					<span v-if="data.test_state == 3">{{data.test_date}}</span>
					<span v-else>-</span>
				</template>
				
				<!--质检数-->
				<template #test_count="{data}">
					<span v-if="data.test_state == 3">{{data.test_count}}</span>
					<span v-else>-</span>
				</template>
				<!--质检数-合计行-->
				<template #test_count_summed="{total}">
					{{total}}
				</template>
				
				<!--质检合格数-->
				<template #test_fine_count="{data}">
					<span v-if="data.test_state == 3">{{data.test_fine_count}}</span>
					<span v-else>-</span>
				</template>
				<!--质检合格数-合计行-->
				<template #test_fine_count_summed="{total}">
					{{total}}
				</template>
				
				<!--质检不合格数-->
				<template #test_defects_count="{data}">
					<span v-if="data.test_state == 3">{{data.test_defects_count}}</span>
					<span v-else>-</span>
				</template>
				<!--质检不合格数-合计行-->
				<template #test_defects_count_summed="{total}">
					{{total}}
				</template>
				
				<!--质检良品率-->
				<template #test_fine_ratio="{data}">
					<span v-if="data.test_state == 3">{{data.test_fine_ratio}}%</span>
					<span v-else>-</span>
				</template>

				<!--计价方式-->
				<template #pricing_type="{data}">
					<c-state dict="pricingTypeDic" :value="data.pricing_type"></c-state>
				</template>
				
				<!--工资单价-->
				<template #price="{data}">
					￥{{parseFloat(parseFloat(data.price).toFixed(6))}}
				</template>
				
				<!--预计工资-->
				<template #pre_salary="{data}">
					￥{{parseFloat(data.pre_salary).toFixed(2)}}
				</template>
				
				<!--产品来源-->
				<template #product_source="{data}">
					<c-state dict="productSourceName" :value="data.product_source"></c-state>
				</template>
				
				<!--产品类型-->
				<template #product_type="{data}">
					<c-state dict="productTypeName" :value="data.product_type"></c-state>
				</template>
				
				<!--工单状态-->
				<template #work_state="{data}">
					<c-state dict="orderStateDic" tag :value="data.work_state"></c-state>
				</template>
				
				<!--任务状态-->
				<template #task_state="{data}">
					<c-state dict="orderStateDic" tag :value="data.task_state"></c-state>
				</template>
				
				<!--审批状态-->
				<template #state="{data}">
					<c-state v-if="data.state == 0" dict="auditStateDic" :value="data.state"></c-state>
					<c-switch v-else-if="auth('b_output_audit') " :state-value="[2, 1]" :state-text="['已审','待审',]" :value="data.state" @change="auditOutput(data,$event)"></c-switch>
					<c-state v-else dict="auditStateDic" :value="data.state"></c-state>
				</template>
				
				<!--工单编号-->
				<template v-if="auth('m_work')" #work_code="{data}">
					<c-link @click="globalDialog('workDetail', {props: {id: data.work_id}})">{{data.work_code}}</c-link>
				</template>
				
				<!--工序编号-->
				<template v-if="auth('m_task')" #process_code="{data}">
					<c-link @click="globalDialog('taskDetail', {props: {id: data.task_id}})">{{data.process_code}}</c-link>
				</template>
				
				<!--工序名称-->
				<template v-if="auth('m_task')" #process_name="{data}">
					<c-link @click="globalDialog('taskDetail', {props: {id: data.task_id}})">{{data.process_name}}</c-link>
				</template>
				
				<!--关联单据-->
				<template #ref_code="{data}">
					<order-link :type="data.ref_type" :id="data.ref_id" :code="data.ref_code"></order-link>
				</template>
				
				<!--生产效率-->
				<template #efficiency="{data}">
					<span v-if="data.efficiency">{{data.efficiency}}%</span>
					<span v-else>-</span>
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="180"
					button-limit="3"
				>
					<template #default="{data}">
						<c-table-button icon="tf-detail" @click="globalDialog('outputDetail', {props: {id: data.id}})">查看</c-table-button>
						<c-table-button v-if="auth('b_output_edit')" v-lock="lock('b_output_edit')" :disabled="!((data.test_state==1 || data.test_state == 2) && data.state ==1)" icon="tf-edit" @click="editOutput(data)">编辑</c-table-button>
						<c-table-button v-if="auth('b_output_edit') && (data.test_state==1 || data.test_state == 2) && data.state ==0" v-lock="lock('b_output_edit')" icon="tf-edit" @click="editOutput(data)">提交</c-table-button>
						<c-table-button v-if="auth('b_output_edit_price')" v-lock="lock('b_output_edit_price')" :disabled="data.state != 1" icon="tf-edit" @click="editOutputPrice(data)">修改工资</c-table-button>
						<c-table-button v-if="auth('b_output_print')" v-lock="lock('b_output_print')" :disabled="data.state == 0" icon="tf-print" @click="$refs.view.exportByTemplate(data.id)">打印</c-table-button>
						<c-table-button v-if="auth('b_output_delete')" v-lock="lock('b_output_delete')" :disabled="!(data.state == 1 && data.test_state !=3)" icon="tf-trash" @click="removeOutput(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</view-list>
			
			<!--编辑报工工资信息弹窗-->
			<output-price ref="outputPrice" @resolve="updateMethod"></output-price>
			
			<!--批量编辑报工工资信息弹窗-->
			<batch-output-price ref="batchOutputPrice" @resolve="updateMethod"></batch-output-price>
			
			<output-config ref="outputConfig"></output-config>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import outputPrice from "@/pages/production/output_price.vue"
	import batchOutputPrice from "@/pages/production/batch_output_price.vue"
	import outputConfig from './output_config.vue'
	
	export default {
		components: {
			outputPrice, batchOutputPrice, outputConfig
		},

		data() {
			return {
                workType:14,
				editFlag: false
			}
		},
		
		computed: {
			// 获取dictName选项数据
			...mapState(['userInfo', 'auditStateDic', 'outputTypeDic', 'testModeDic', 'testStateDic'])
		},
		
		mounted() {
		    this.$bus.$on('output.list.update', data => {
		        // 刷新列表
		        this.$refs.view.refresh();
		    });

			this.getSys().setHeadButton([{
				name: '报工页配置',
				icon: 'tf-order-config',
				auth: 'b_output_viewmanage',
				handle: () => {
					this.$refs.outputConfig.open();
				}
			}])
		},
		
		beforeDestroy() {
			this.$bus.$off('output.list.update');
		},
		
		methods: {
			searchProcess(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'DICPROCESS_SEARCH',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},

			updateMethod(){
				//修改
				if(this.editFlag){
					this.$refs.view.refresh();
				}else{
					this.$refs.view.update();
				}
			},
			/******新建/编辑报工*******/
			editOutput(data) {
				if(data){
					this.editFlag = true;
				}else{
					this.editFlag = false;
				}
				this.globalDialog('outputEdit', {
					data
				}, this.updateMethod);
			},
			
			/******批量修改报工工资单价*******/
			batchEditOutputPrice(data) {
				var ids = [];
				this.$refs.view.$refs.list.getData('selected').forEach(item => {
					ids.push(item.id);
				});
				this.$refs.batchOutputPrice.open(ids);
			},
			
			/******修改报工工资单价*******/
			editOutputPrice(data) {
				this.editFlag = true;
				this.$refs.outputPrice.open(data);
			},
			
			//审核或改为未审核
			auditOutput(inData, state){
				this.request({
					url:'/output/editState',
					data: {
						id: inData.id,
						state: state
					},
					success:data => {
						this.$message({
							type: 'success',
							message:'变更审核状态成功',
						});
						//审核通过
						if(state == 1){
							inData.audit_user_realname = '';
							inData.audit_user_id = 0;
							inData.audit_date = '';
						//审核不通过
						}else{
							inData.audit_user_realname = this.userInfo.user_realname;
							inData.audit_user_id = this.userInfo.name;
							inData.audit_date = new Date().format('yyyy-MM-dd hh:mm');
						}
						inData.state = state;
					}
				})
			},
			
			/****批量审批报工**/
			batchAuditOutput(){
				var ids = [];
				this.$refs.view.$refs.list.getData('selected').forEach(item => {
					ids.push(item.id);
				});
				
				this.$confirm({
					title: '报工审批确认',
					message:'确认审批' + ids.length + '条报工记录吗？',  // 提示内容,
					buttons: [
						{name: '审批通过', value: 2, color: true},
						{name: '撤销审批', value: 1, color: false},
						{name: '取消', value: 0, color: false},
					],
					resolve: (state) => {
						if(state != 0){
							this.request({
								url: '/output/editState/batch',
								data: {ids: ids, state: state},
								loading: true,
								success: data => {
									let Mtype = 'success';
									let message = '成功' + data.success_count + '条';
									if(data.fail_count > 0 && data.success_count > 0){
										Mtype = 'warn';
										message += '，失败'+data.fail_count+'条';
									}else if(data.fail_count > 0 && data.success_count == 0){
										Mtype = 'fail'
										message += '，失败'+data.fail_count+'条';
									}else{
										message = data.success_count + '条报工记录审批成功';
									}
									this.$message({
										message: message,  // 提示内容,
										type: Mtype
									});
									//刷新
									this.$refs.view.refresh();
								}
							});
						}
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},
			
			/****批量删除报工**/
			batchRemoveOutput(){
				var ids = [];
				this.$refs.view.$refs.list.getData('selected').forEach(item => {
					ids.push(item.id);
				});
				
				this.$confirm({
					message:'确认删除' + ids.length + '条报工记录吗？删除后不可恢复',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/output/delete/batch',
							data: {ids: ids},
							loading: true,
							success: data => {
								let Mtype = 'success';
								let message = '成功' + data.success_count + '条';
								if(data.fail_count > 0 && data.success_count > 0){
									Mtype = 'warn';
									message += '，失败'+data.fail_count+'条';
								}else if(data.fail_count > 0 && data.success_count == 0){
									Mtype = 'fail'
									message += '，失败'+data.fail_count+'条';
								}else{
									message = '成功删除' + data.success_count + '条记录';
								}
								this.$message({
									message: message,  // 提示内容,
									type: Mtype
								});
								//刷新
								this.$refs.view.refresh();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},
			
			/******删除报工************/
			removeOutput(data){
				this.$confirm({
					message:'确认删除此报工记录吗？删除后不可恢复',  // 提示内容,
					// buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/output/delete',
							data: {id:data.id},
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',  // 提示内容,
									type: 'success'
								});
								//刷新
								this.$refs.view.refresh();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			/*******搜索【员工】下拉框信息*****************/
			searchOutputUser(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'SYSUSER',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
		}
	}
</script>

<style lang="stylus" scoped>
</style>